//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/Builder.js";
import "../no/SelectICurveList.js";
import "../no/SelectDisplayableObject.js";
import "../Facet/Facet.SelectFacetedBody.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[1,"BridgeEdges1",0,"SelectICurveList",0],[1,"BridgeEdges2",0,"SelectICurveList",0],[1,"InnerHole",0,"SelectICurveList",0],[0,"IsEditCopy",1,0],[0,"MaxEdges",1,0],[1,"OuterHole",0,"SelectICurveList",0],[0,"SmoothType",1,0],[1,"TargetBody",0,"SelectDisplayableObject",0],[1,"TargetFacetBody",0,"Facet.SelectFacetedBody",1],[1,"TargetHole",0,"SelectICurveList",0],[0,"TargetType",1,0],[0,"Type",1,0]],[[[],"ClearHoles",{},0,0],[[],"FindHoles",{},0,0],[[],"ClearHoleFills",{},0,0],[["globalUpdate"],"FillHoles",{R_:{newFacetBody:"DisplayableObject"}},1,0],[[],"SwitchHoleFillType",{},0,0],[[],"GetHoleFillsOnly",{R_:{facetBodyResult:"DisplayableObject"}},0,0],[["nHoles","holeCurveTags"],"GetAllHoles",{},0,0],[[],"GetNumberOfHoles",{R_:{numberOfHoles:''}},0,0],[["index"],"GetHoleByIndex",{R_:{holeAtIndex:"ICurve"}},1,0],[["numMaxEdges","nHoles","holeCurveTags"],"GetTargetHolesByEdgeNumber",{},1,0]],[]];
SPLM.Facet.FillHoleBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.FillHoleBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.FillHoleBuilder.Types = Object.freeze({
    "FillHole" : "FillHole", "FillIsland" : "FillIsland", "BridgeGap" : "BridgeGap"});

SPLM.Facet.FillHoleBuilder.TargetTypes = Object.freeze({
    "UserDefined" : "UserDefined", "ByNumberOfEdges" : "ByNumberOfEdges"});

SPLM.Facet.FillHoleBuilder.SmoothTypes = Object.freeze({
    "Linear" : "Linear", "Refined" : "Refined", "TangentBased" : "TangentBased", "CurvatureBased" : "CurvatureBased"});

export default SPLM;